import _ from 'lodash';
import template from './gasMeterPanel.html';

export default {
  name: 'gasMeterPanel',
  template,
  controller: GasMeterPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function GasMeterPanelController(
  $scope,
  orderGasMeterObjectFilter,
  GasMeterPanelService,
  EquipmentInfoService,
  DashboardService
) {
  const vm = this;

  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.gasMeters = null;

  /**
   * Public Methods
   */
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = deleteModel;
  vm.updateCurrentReadingFromEvent = updateCurrentReadingFromEvent;
  vm.deleteModel = deleteModel;


  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.loadingSpinners.stopGasMeterPanel = false;
      vm.editPanel.needsToBeConfigured = false;

      EquipmentInfoService.getFullEquipment(vm.panel.equipment)
        .then((success) => {
          _.forEach(success, (eq) => {
            GasMeterPanelService.getLatestEvent(eq, vm.panel)
              .finally(() => {
                vm.gasMeters = orderGasMeterObjectFilter(
                  GasMeterPanelService.getModel(vm.panel.id),
                  'VGT Var VGY'
                );
                vm.loadingSpinners.stopGasMeterPanel = true;
              });
          });
        });
    } else {
      // panel needs to be configured
      vm.loadingSpinners.stopGasMeterPanel = true;
      vm.editPanel.needsToBeConfigured = true;
    }
  }

  function postLink() {
    _.forEach(vm.panel.equipment, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, (__, eventObj) => {
        vm.updateCurrentReadingFromEvent(vm.panel.id, eventObj);
      });
    });
  }

  function updateCurrentReadingFromEvent(panelId, eventObj) {
    GasMeterPanelService.updateModelFromEvent(panelId, eventObj);
  }

  function deleteModel() {
    GasMeterPanelService.deleteModel();
  }
}
